import React from 'react';

const InfoTooltip: React.FC<{ text: string }> = ({ text }) => (
  <span className="group relative inline-flex items-center cursor-pointer ml-1">
    <span className="text-blue-500 text-sm">ℹ️</span>
    <span className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 max-w-xs w-max bg-white text-gray-800 text-xs shadow-lg border px-3 py-2 rounded hidden group-hover:block z-50 whitespace-normal break-words">
      {text}
    </span>
  </span>
);

export default InfoTooltip; 